<template>
    <div class="visibility-changer">
        <div style="margin-bottom: 10px" v-if="!!user.role.isRoot">
            <span class="title">Temsilci Mailleri</span>
            <span class="description"
                >Diğer temsilcilerin mail adresine gelen ve giden e-postaları takip edebilirsiniz</span
            >
            <a-switch v-model="isAgentMailVisible" class="ml-2 mr-2" size="small" @change="changeIsAgentMailVisible" />
        </div>

        <div>
            <b-form-group :label="$t('mail.mailSelecting')" label-for="type-input" class="form-group-user">
                <b-form-select
                    id="type-input"
                    v-model="selectedMailId"
                    :data-vv-as="$t('message.contentType')"
                    :name="$t('message.contentType')"
                    type="text"
                >
                    <option :value="getUserMail._id" v-for="getUserMail in getUserMailList()">
                        {{ getUserMail.mail }}
                    </option>
                </b-form-select>
            </b-form-group>
        </div>
        <div class="title" v-if="showTitle">{{ $t("mail_integration_detail.visibility") }}</div>
        <a-alert type="info" show-icon v-if="getIsPublic()" :message="$t('message.visibilityInfoCont')" />

        <div v-else class="lines">
            <div class="subtitle">{{ $t("message.visibleAgents") }}</div>
            <div class="agents">
                <div v-for="id of cloneUserIds" class="agent" :key="id">
                    <Avatar
                        :size="50"
                        :src="getUser(id).gravatar"
                        :username="getUser(id).name"
                        class="mr-2 visibility-avatar"
                    />
                    <div
                        class="delete-icon"
                        @click="deleteAgent(id)"
                        v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                        :content="getUser(id).name"
                    ></div>
                </div>
                <div>
                    <button @click="visibleAgentModal = true" class="add-btn">
                        <span class="md-icon" style="color: #fff; padding-right: 2px"> add </span>
                    </button>
                </div>
            </div>

            <div class="subtitle">{{ $t("message.visibleDepartments") }}</div>
            <div class="agents">
                <div v-for="id of cloneDepartmentIds" class="agent" :key="id">
                    <Avatar
                        :size="50"
                        :src="undefined"
                        :username="getDepartmentTitle(getDepartment(id))"
                        class="mr-2 visibility-avatar"
                    />
                    <div
                        class="delete-icon"
                        @click="deleteDepartment(id)"
                        v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                        :content="getDepartmentTitle(getDepartment(id))"
                    ></div>
                </div>
                <div>
                    <button @click="visibleDepartmentModal = true" class="add-btn">
                        <span class="md-icon" style="color: #fff; padding-right: 2px"> add </span>
                    </button>
                </div>
            </div>
        </div>

        <a-divider />

        <div class="buttons">
            <a-button type="primary" @click="visibleAgentModal = true">
                {{ $t("message.editAgentVisibility") }}
            </a-button>
            <a-button type="primary" @click="visibleDepartmentModal = true">
                {{ $t("message.editDepartmentVisibility") }}
            </a-button>
        </div>

        <FormModal
            :title="$t('message.selectAgent')"
            :subtitle="$t('message.selectAgentDesc')"
            v-if="visibleAgentModal"
            v-model="cloneUserIds"
            @cancel="visibleAgentModal = false"
        >
            <template #body>
                <div class="pf-main">
                    <div class="pr-search">
                        <input :placeholder="$t('message.searchRepresentative')" v-model="searchText" />
                        <span class="material-icons mx-2 pr-icon"> search </span>
                    </div>
                    <hr />
                    <div class="pr-items pr-item-wrapper">
                        <div class="pr-item" v-for="agent of getFilteredUsers()" @click="toggleAgent(agent._id)">
                            <a-checkbox class="segment-checkbox" :checked="cloneUserIds.includes(agent._id)" />

                            <div class="user-data-wrapper">
                                <div class="user-data">
                                    <Avatar
                                        :size="30"
                                        :src="agent.gravatar"
                                        :username="agent.name"
                                        class="mr-2 visibility-avatar"
                                    />
                                    <div class="metas">
                                        <div class="pr-item-name">{{ agent.name }}</div>
                                        <div>
                                            {{ getAgentDepartmentNames(agent) }}
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="pr-item-status"
                                    :data-online="$_.get(user, '_id') === agent._id ? true : agent.isOnline"
                                    :data-status="agent.status.toLowerCase()"
                                >
                                    <div class="pr-item-status-circle"></div>
                                    {{ agent.status }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="actions">
                    <a-button class="pr-confirm-btn" @click="handleSave" type="primary">
                        {{ $t("message.save") }}
                    </a-button>
                </div>
            </template>
        </FormModal>
        <FormModal
            :title="$t('message.selectDepartment')"
            :subtitle="$t('message.selectDepartmentDesc')"
            v-if="visibleDepartmentModal"
            v-model="cloneDepartmentIds"
            @cancel="visibleDepartmentModal = false"
        >
            <template #body>
                <div class="pf-main">
                    <div class="pr-search">
                        <input :placeholder="$t('message.searchRepresentative')" v-model="searchText" />
                        <span class="material-icons mx-2 pr-icon"> search </span>
                    </div>
                    <hr />
                    <div class="pr-items pr-item-wrapper">
                        <div
                            class="pr-item"
                            v-for="item of getFilteredDepartments()"
                            @click="toogleDepartment(item._id)"
                        >
                            <a-checkbox class="segment-checkbox" :checked="cloneDepartmentIds.includes(item._id)" />

                            <div class="user-data-wrapper">
                                <div class="user-data">
                                    <Avatar
                                        :size="30"
                                        :src="undefined"
                                        :username="item.languageContent[$i18n.locale].name"
                                        class="mr-2 visibility-avatar"
                                    />
                                    <div class="metas">
                                        <div class="pr-item-name">
                                            {{ item.languageContent[$i18n.locale].name }}
                                        </div>
                                    </div>
                                </div>

                                <div class="pr-item-status">
                                    <div class="avatar-group">
                                        <Avatar
                                            v-for="user of getDepartmentUsers(item._id, 2)"
                                            :key="user._id"
                                            :size="30"
                                            :src="user.gravatar"
                                            :username="user.name"
                                            class="avatar-wrapper"
                                        />
                                        <div
                                            class="extra avatar-wrapper"
                                            v-if="getDepartmentUsers(item._id).length > 2"
                                        >
                                            +{{ getDepartmentUsers(item._id, 2).length - 2 }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="actions">
                    <a-button class="pr-confirm-btn" @click="handleSave" type="primary">
                        {{ $t("message.save") }}
                    </a-button>
                </div>
            </template>
        </FormModal>
    </div>
</template>
<script>
import Vue from "vue";
import { mapGetters, mapState, mapActions } from "vuex";
import FormModal from "../../../../components/FormModal.vue";
import _ from "lodash";
import Avatar from "vue-avatar";

export default Vue.extend({
    name: "VisibilityChanger",
    components: { FormModal, Avatar },
    props: {},
    data() {
        return {
            visibleAgentModal: false,
            visibleDepartmentModal: false,
            cloneUserIds: [],
            cloneDepartmentIds: [],
            searchText: "",
            showTitle: true,
            selectedMailId: "",
            isAgentMailVisible: true,
        };
    },
    computed: {
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
        }),
        ...mapState({
            users: (state) => state.user.users.data,
            user: (state) => state.auth.user,
            departments: (state) => state.subject.subjects.data,
            site: (state) => state.site.site,
            allMailAddresses: (state) => state.mail.allMailAddresses,
        }),
    },
    methods: {
        ...mapActions({
            changeVisibility: "mail/changeVisibility",
            getVisibilityUser: "mail/getVisibilityUser",
            changeIsAgentMailVisibleAction: "mail/changeIsAgentMailVisible",
            getAgentMailVisibility: "mail/getAgentMailVisibility",
        }),
        async changeIsAgentMailVisible() {
            await this.changeIsAgentMailVisibleAction({ userId: this.user._id, visible: this.isAgentMailVisible });
        },
        getUserMailList() {
            console.log("getUserMailList allMailAddresses work..", this.allMailAddresses);
            return this.allMailAddresses.filter(
                (email) => email.type === "user" && !!email.user && email.user._id === this.user._id
            );
        },
        getDepartmentTitle(department) {
            if (department === undefined) return "N/A";
            const langs = Object.keys(department?.languageContent || {});
            const targetLang = langs.includes(this.$i18n.locale) ? this.$i18n.locale : langs[0];
            return _.get(department, `languageContent.${targetLang}.name`);
        },
        getUser(userId) {
            return this.users.find((user) => user._id === userId);
        },
        getIsPublic() {
            return this.cloneUserIds.length === 0 && this.cloneDepartmentIds.length === 0;
        },
        getDepartment(id) {
            return this.departments.find((department) => department._id === id);
        },
        getFilteredUsers() {
            let q = this.searchText.split("").join(".*");
            return this.users.filter((x) => new RegExp(q, "gi").test(x.name));
        },
        getFilteredDepartments() {
            let q = this.searchText.split("").join(".*");
            return this.departments.filter((x) => new RegExp(q, "gi").test(x.name));
        },
        deleteAgent(agentId) {
            this.toggleAgent(agentId);
            this.handleSave();
        },
        deleteDepartment(departmentId) {
            this.toogleDepartment(departmentId);
            this.handleSave();
        },
        toggleAgent(agentId) {
            this.cloneUserIds = this.cloneUserIds.includes(agentId)
                ? this.cloneUserIds.filter((x) => x !== agentId)
                : [...this.cloneUserIds, agentId];
        },
        toogleDepartment(departmentId) {
            this.cloneDepartmentIds = this.cloneDepartmentIds.includes(departmentId)
                ? this.cloneDepartmentIds.filter((x) => x !== departmentId)
                : [...this.cloneDepartmentIds, departmentId];
        },
        async handleSave() {
            this.visibleAgentModal = false;
            this.visibleDepartmentModal = false;
            console.log("handle save..", { users: this.cloneUserIds, departments: this.cloneDepartmentIds });
            await this.changeVisibility({
                mail: this.allMailAddresses.filter((x) => x._id === this.selectedMailId)[0].mail,
                id: this.user._id,
                visibility: { users: this.cloneUserIds, departments: this.cloneDepartmentIds },
            });
        },
        handleSaveDepartmentModal() {
            this.visibleDepartmentModal = false;
        },
        getAgentDepartmentNames(user) {
            return (user.subjects || []).length
                ? this.departments
                      .filter((x) => (user.subjects || []).includes(x._id))
                      .map(
                          (x) =>
                              _.get(x, `languageContent.${this.$i18n.locale}.name`) ||
                              _.get(x, `languageContent.${Object.keys(x.languageContent)[0]}.name`)
                      )
                      .join(",")
                      .toLowerCase()
                : this.$t("message.allDepartments");
        },
        getDepartmentUsers(departmentId, take) {
            const users = this.users.filter((x) => (x.subjects || []).includes(departmentId));
            if (take) {
                return users.slice(0, take);
            } else {
                return users;
            }
        },
    },
    async mounted() {
        this.getAgentMailVisibility(this.user._id).then((res) => {
            console.log("visibilityList res...", res);
            this.isAgentMailVisible = res.agentMailVisibility;
            console.log("visibilityList isAgentMailVisible...", this.isAgentMailVisible);
        });
        this.selectedMailId = this.$route.params.id;
        const mailAddress = await this.getVisibilityUser(this.$route.params.id);
        console.log("visibilityList work", mailAddress);
        this.cloneUserIds = mailAddress ? mailAddress.visibility.users : [];
        this.cloneDepartmentIds = mailAddress ? mailAddress.visibility.departments : [];
    },
    watch: {
        async selectedMailId(val) {
            const mailAddress = await this.getVisibilityUser(val);
            this.cloneUserIds = mailAddress ? mailAddress.visibility.users : [];
            this.cloneDepartmentIds = mailAddress ? mailAddress.visibility.departments : [];
        },
    },
});
</script>

<style scoped lang="scss">
.visibility-changer {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin: 10px;

    .buttons {
        display: flex;
        gap: 5px;
    }

    .lines {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .title {
        font-weight: 700;
        color: var(--color-text-strong-default);
        font-size: 18px;
        line-height: 32px;
    }

    .subtitle {
        font-weight: 700;
        color: var(--color-text-strong-default);
        font-size: 14px;
        line-height: 32px;
    }

    .agents {
        display: flex;
        flex-direction: row;
        gap: 5px;
        flex-wrap: wrap;

        .agent {
            position: relative;

            &:hover {
                .delete-icon {
                    display: grid;
                }
            }
        }
    }
}

.pf-main {
    display: flex;
    flex-direction: column;
    background: var(--color-bg-default);
    border: 1px solid var(--color-border-default);
    padding: 5px;

    .pr-search {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 100%;

        input {
            border: 1px solid #c6cdd4 !important;
            width: 100%;
            padding: 10px;
            padding-right: 40px;
            border-radius: 5px;
            transition: all 0.3s;
        }

        input:focus {
            border: 1px solid black !important;
        }

        .pr-icon {
            position: absolute;
            right: 4px;
        }
    }

    .pr-items {
        min-height: 300px;
        max-height: 300px;
        overflow: auto;

        .pr-item:last-child {
            border-bottom: none;
        }

        .pr-item {
            display: flex;
            justify-content: start;
            align-items: center;
            flex-wrap: nowrap;
            padding: 5px 10px;
            border-radius: 4px;
            cursor: pointer;
            gap: 10px;
            border-bottom: 1px solid var(--color-border-default);

            &:hover {
                background: var(--color-bg-neutral-hover);
            }

            .user-data-wrapper {
                width: 100%;
                display: flex;
                justify-content: space-between;

                padding: 0 5px;

                .user-data {
                    display: flex;
                    gap: 5px;
                    align-items: center;

                    .visibility-avatar {
                        color: var(--color-text-onprimary-default);
                    }

                    .metas {
                        display: flex;
                        flex-direction: column;
                    }
                }
            }

            .pr-item-status {
                display: flex;
                justify-content: center;
                align-items: center;

                .pr-item-status-circle {
                    width: 10px;
                    height: 10px;
                    border-radius: 100%;
                    margin-right: 2px;
                }

                &[data-online="true"] {
                    &[data-status="online"] {
                        color: #1bc5bd !important;

                        .pr-item-status-circle {
                            background: #1bc5bd !important;
                        }
                    }

                    &[data-status="away"] {
                        color: #3699ff !important;

                        .pr-item-status-circle {
                            background: #3699ff !important;
                        }
                    }

                    &[data-status="busy"] {
                        color: #ffa829 !important;

                        .pr-item-status-circle {
                            background: #ffa829 !important;
                        }
                    }

                    &[data-status="offline"] {
                        color: #f64e60 !important;

                        .pr-item-status-circle {
                            background: #f64e60 !important;
                        }
                    }
                }

                &:not([data-online]) {
                    &[data-status="online"] {
                        color: var(--color-text-disabled);

                        .pr-item-status-circle {
                            background: var(--color-text-disabled) !important;
                        }
                    }

                    &[data-status="away"] {
                        color: var(--color-text-disabled);

                        .pr-item-status-circle {
                            background: var(--color-text-disabled) !important;
                        }
                    }

                    &[data-status="busy"] {
                        color: var(--color-text-disabled);

                        .pr-item-status-circle {
                            background: var(--color-text-disabled) !important;
                        }
                    }

                    &[data-status="offline"] {
                        color: var(--color-text-disabled);

                        .pr-item-status-circle {
                            background: var(--color-text-disabled) !important;
                        }
                    }
                }
            }
        }
    }
}

.add-btn {
    height: 50px;
    width: 50px;
    border-radius: 50%;
    background: #d7d9da;
    border: 0px;
}

.add-btn:hover {
    background: #696a6b;
}

.avatar-group {
    display: inline-flex;
}

.avatar-wrapper {
    margin-inline-start: -8px;

    &.extra {
        width: 34px;
        height: 32px;
        border-radius: 50%;
        border-color: white;
        color: rgb(245, 106, 0);
        background-color: rgb(253, 227, 207);
        display: flex;
        justify-content: center;
        align-items: center;
    }
}

.avatar-wrapper:first-child {
    margin-inline-start: unset;
}

.delete-icon {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.4);
    position: absolute;
    top: 0;
    left: 0;
    display: none;
    place-items: center;
    cursor: pointer;

    &:after {
        display: inline-block;
        content: "\00d7";
        color: rgba(255, 255, 255, 0.8);
        font-size: 35px;
    }
}
</style>
<style lang="scss">
.visibility-avatar {
    span {
        color: var(--color-text-onprimary-default);
    }
}
</style>
